ixModuleRouting("impactx.uploadservicebrowser", {
    "/uploadservicebrowser": {
        template: "<ixa-upload-service-browser-list></ixa-upload-service-browser-list>",
        templateUrl:
            "modules/uploadservicebrowser/templates/filebrowserlist.html",
        controller: "UploadServiceBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "UploadServiceBrowserView",
    },
    "/uploadservicebrowser/:path": {
        template: "<ixa-upload-service-browser-list></ixa-upload-service-browser-list>",
        templateUrl:
            "modules/uploadservicebrowser/templates/filebrowserlist.html",
        controller: "UploadServiceBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "UploadServiceBrowserView",
    },
});
